import { cloneElement, useState } from "react";

import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

interface ConfirmActionButtonProps {
  title: string;
  description?: string;
  onConfirm: () => void;
  actionButton: JSX.Element;
  onCancel?: () => void;
  dataTestId?: string;
}

export const ConfirmActionButton = ({
  title,
  description,
  onConfirm,
  actionButton,
  onCancel,
  dataTestId,
}: ConfirmActionButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const confirmButton = cloneElement(actionButton, {
    onClick: () => setIsOpen(true),
  });

  const cancel = () => {
    setIsOpen(false);
    onCancel?.();
  };

  return (
    <>
      {confirmButton}
      <Modal
        isOpen={isOpen}
        onClose={cancel}
        titleContent={title}
        hideCloseButton
      >
        <p className="text-sm mb-4 text-[#717680]">{description}</p>
        <div className="flex space-x-3" data-testid={dataTestId}>
          <PrimaryButton
            onClick={() => {
              onConfirm();
              setIsOpen(false);
            }}
          >
            CONFIRM
          </PrimaryButton>
          <SecondaryButton onClick={cancel}>CANCEL</SecondaryButton>
        </div>
      </Modal>
    </>
  );
};
